__turbopack_context__.v({
  "shimmer": "ChartSkeleton-module__fmTa4a__shimmer",
});
